import React from 'react';
import NotFoundError from './NotFoundError'
import { Tabs, Tab } from 'react-bootstrap';

import * as Help from 'modules/app/Help';
import * as Notifications from 'fw/globals/Notifications';
import * as App from 'modules/app/App';

class SetupTabView extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState(props) {
		return {
			tabs: props.setupProps.tabs,
			defaultTabKey: props.setupProps.tabs[0].key,
			activeTabKey: props.setupProps.tabs[0].key,
			activeReviewMode: this.props.match.params.reviewMode,
			selectedId: this.props.match.params.id,
			adding: this.props.adding,
			notFound: false
		};
	}

	setHelp = () => {
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();
	}

	dispatchResize = () => {
		if (document.createEventObject) {
			window.fireEvent('resize');
		}
		else {
			var evt = document.createEvent("HTMLEvents");
			evt.initEvent('resize', false, true);
			window.dispatchEvent(evt);
		}
	}

	navigateToTab = (key) => {
		var url = this.props.setupProps.match.url
			+ '/' + this.props.match.params.id
			+ '/' + key;

		if (this.props.match.params.reviewMode)
			url = url + '/' + this.props.match.params.reviewMode;

		this.props.history.push(url);
	}

	// Handlers
	handleSave = (savedId) => {
		// On new, refresh tab
		if (this.props.adding) {
			var url = `${this.props.setupProps.match.url}/${savedId}/${this.state.defaultTabKey}`;
			this.props.history.push(url);
		}

		this.props.onSave(savedId);
	}

	handleCancel = () => {
		const me = this;

		me.props.onBack();
	}

	handleDelete = () => {
		this.props.onDelete();
	}

	handleSuccess = (successData) => {
		Notifications.success(successData);
	}

	handleError = (error) => {
		Notifications.error(error.errorMessage);
	}

	handleNotFound = (error) => {

		this.setState({
			notFound: true,
			errorMessage: error.errorMessage
		});
	}

	handleTabEnter = (a) => {
		this.dispatchResize();
	}

	handleTabSelect = (key) => {
		const me = this;

		// New item? Disable any tab navigation
		if (!this.state.selectedId)
			return;

		// This tab doesn't handle save, or it's not dirty
		if (!this._activeTab.isDirty || !this._activeTab.isDirty()) {
			this.navigateToTab(key)
			return;
		}

		// If it's dirty, save, then navigate
		if (this._activeTab.save) {
			this._activeTab.beforeSave(() => {
				me._activeTab.save({
					success: () => {
						this.navigateToTab(key);
					}
				});
			});
		}
	}

	setWarnOnBack = (warn) => {
		this.props.onSetWarnOnBack(warn);
	}

	// React
	componentWillReceiveProps(nextProps) {
		// Changed ID?
		if (this.props.match.params.id !== nextProps.match.params.id)
			this.setState({ selectedId: nextProps.match.params.id });

		// Changed Tab?
		if (this.props.match.params.tabKey !== nextProps.match.params.tabKey)
			this.setState({ activeTabKey: nextProps.match.params.tabKey });

		// Changed Review Mode?
		if (this.props.match.params.reviewMode !== nextProps.match.params.reviewMode)
			this.setState({ activeReviewMode: nextProps.match.params.reviewMode });
	}

	componentWillMount() {
		// Load selected ID and Tab
		this.setState({
			selectedId: this.props.match.params.id,
			activeTabKey: this.props.match.params.tabKey || this.props.setupProps.tabs[0].key,
			activeReviewMode: this.props.match.params.reviewMode
		});
	}

	render() {
		let selectedId = this.state.selectedId;
		let queueTypeCode = null;

		if (this.state.activeReviewMode) {
			queueTypeCode = this.state.activeReviewMode;
		}

		if (this.state.notFound)
			return (<NotFoundError 
				hideBack={App.context().lastSetupTabIsSingle != null && App.context().lastSetupTabIsSingle}
				homeUrl={this.props.setupProps.homeUrl != null ? this.props.setupProps.homeUrl : null}
				backUrl={this.props.setupProps.backUrl != null ? this.props.setupProps.backUrl : null}
				message={this.state.errorMessage} />)

		const SetupTabs = this.state.tabs.map((tab, index) => {
			const Comp = tab.comp;

			const disabled = (!selectedId && (index > 0)) || tab.disabled;

			const active = (this.state.activeTabKey === tab.key);
			const ref = active ? (t) => { this._activeTab = t } : null;

			return (
				<Tab
					key={index}
					eventKey={tab.key}
					title={tab.title}
					disabled={disabled}
					onEnter={this.props.onTabEnter}>
					<div className='tab-pane'>
						<div className='panel-body'>
							<Comp
								tabKey={tab.key}
								tooltips={tab.tooltips}
								active={active}
								helpKey={tab.helpKey}
								recentType={this.props.setupProps.recentType}
								showTitle={this.props.setupProps.showTitle}
								showButtons={this.props.setupProps.showButtons}
								setupProps={this.props.setupProps}
								selectedId={selectedId}
								queueTypeCode={queueTypeCode}
								onSave={this.handleSave}
								onCancel={this.handleCancel}
								onDelete={this.handleDelete}
								onError={this.handleError}
								onSuccess={this.handleSuccess}
								onNotFound={this.handleNotFound}
								handleTabSelect={this.handleTabSelect}
								ref={ref}
								onSetWarnOnBack={this.setWarnOnBack} />
						</div>
					</div>
				</Tab>)
		});

		return (
			<React.Fragment>
				<div>
					<Tabs id="setupTabs"
						onSelect={this.handleTabSelect}
						activeKey={this.state.activeTabKey}
						defaultActiveKey={this.state.defaultTabKeyKey}
						className="tabs-container">
						{SetupTabs}
					</Tabs>
				</div>
			</React.Fragment>
		);
	}
}

export default SetupTabView;




// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupTabView.js